// Custom Color Handler for Variant Picker
// Handles color swatch changes in product variant picker components

window.handleCustomColorChange = async function(element) {
  const productUrl = element.dataset.colorProductUrl;
  const variantColorName = element.dataset.variantColor;
  const genericColorName = element.dataset.genericColor;

  if (!productUrl) return;

  // Find the closest fieldset to this input
  const fieldset = element.closest('fieldset');
  if (!fieldset) return;

  // Clear all color displays first
  const allVariantColorSpans = document.querySelectorAll('.variant-color-name');
  const allGenericColorSpans = document.querySelectorAll('.generic-color-name');

  allVariantColorSpans.forEach(span => span.textContent = '');
  allGenericColorSpans.forEach(span => span.textContent = '');

  // Update the color name display in the current fieldset only
  const variantColorSpan = fieldset.querySelector('.variant-color-name');
  const genericColorSpan = fieldset.querySelector('.generic-color-name');

  if (variantColorSpan) {
    variantColorSpan.textContent = variantColorName;
  }
  if (genericColorSpan) {
    genericColorSpan.textContent = genericColorName || '';
  }

  // Show loading state
  const mainProductSection = document.querySelector('[data-product-root]');
  if (mainProductSection) {
    mainProductSection.style.opacity = '0.6';
    mainProductSection.style.pointerEvents = 'none';
  }

  try {
    // Get the current section ID from the main product section
    const mainProductSection = document.querySelector('[data-product-root]');
    const sectionId = mainProductSection ? mainProductSection.id : 'main-product';

    // Use Shopify's Section API to get the product section
    const sectionResponse = await fetch(productUrl + '?section_id=' + sectionId);

    if (!sectionResponse.ok) {
      throw new Error('Failed to fetch product section');
    }

    const sectionHtml = await sectionResponse.text();

    // Parse the HTML and extract the main product section
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');
    const newProductSection = doc.querySelector('[data-product-root]');

    if (newProductSection && mainProductSection) {
      // Update the URL without page reload
      window.history.pushState({}, '', productUrl);

      // Destroy the current Alpine.js instance
      if (window.Alpine && mainProductSection._x_dataStack) {
        window.Alpine.destroyTree(mainProductSection);
      }

      // Replace the entire section
      mainProductSection.outerHTML = newProductSection.outerHTML;

      // Get the new element reference
      const updatedSection = document.querySelector('[data-product-root]');

      // Reinitialize Alpine.js
      if (window.Alpine && updatedSection) {
        window.Alpine.initTree(updatedSection);
      }

      // After content replacement, find and update the appropriate color display
      // We need to find the checked input and update its fieldset's display
      const newCheckedColor = document.querySelector('input[name="custom_color"]:checked');
      if (newCheckedColor) {
        const newFieldset = newCheckedColor.closest('fieldset');
        if (newFieldset) {
          const newVariantColorSpan = newFieldset.querySelector('.variant-color-name');
          const newGenericColorSpan = newFieldset.querySelector('.generic-color-name');

          if (newVariantColorSpan) {
            newVariantColorSpan.textContent = variantColorName;
          }
          if (newGenericColorSpan) {
            newGenericColorSpan.textContent = genericColorName || '';
          }
        }
      }

      // Dispatch custom event for other components to reinitialize
      window.dispatchEvent(new CustomEvent('product:updated', {
        detail: { productUrl, variantColorName, genericColorName }
      }));
    }
  } catch (error) {
    console.error('Error loading product section:', error);
    // Fallback to page reload if Section API fails
    window.location.href = productUrl;
  } finally {
    // Remove loading state
    const currentSection = document.querySelector('[data-product-root]');
    if (currentSection) {
      currentSection.style.opacity = '';
      currentSection.style.pointerEvents = '';
    }
  }
};
